var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';
import FloorPlanMark from '../../components/FloorPlanMark';
import FloorPlanUpload from '../../components/FloorPlanUpload';
import Footer from '../../components/Footer';
import { FloorPlanEditState } from '../../types/floorplan';
import FloorPlanConnect from '../../components/FloorPlanConnect';
import FloorPlanFinish from '../../components/FloorPlanFinish';
var helperTexts = {
    Upload: 'Upload floor plan layouts',
    Mark: 'Mark the areas',
    Connect: 'Connect people to areas',
    Finish: 'Finish the label order sheet',
};
var dirtyHackForTheHelperText = function (text) {
    var el = document.getElementById('titlebar_left');
    if (el) {
        el.textContent = 'Floor plan:';
        el.setAttribute('data-after', text);
    }
};
var renderFloorPlanState = function (floorPlanStore) {
    if (_.isNil(floorPlanStore.currentFloor)) {
        dirtyHackForTheHelperText(helperTexts.Upload);
        return React.createElement(FloorPlanUpload, { floorPlanStore: floorPlanStore });
    }
    switch (floorPlanStore.editState) {
        case FloorPlanEditState.Upload:
            dirtyHackForTheHelperText(helperTexts.Upload);
            return React.createElement(FloorPlanUpload, { floorPlanStore: floorPlanStore });
        case FloorPlanEditState.Mark:
            dirtyHackForTheHelperText(helperTexts.Mark);
            return React.createElement(FloorPlanMark, { floorPlanStore: floorPlanStore });
        case FloorPlanEditState.Connect:
            dirtyHackForTheHelperText(helperTexts.Connect);
            return React.createElement(FloorPlanConnect, { floorPlanStore: floorPlanStore });
        default:
            dirtyHackForTheHelperText(helperTexts.Finish);
            return React.createElement(FloorPlanFinish, { floorPlanStore: floorPlanStore });
    }
};
var continueNextState = function (floorPlanStore) {
    switch (floorPlanStore.editState) {
        case FloorPlanEditState.Upload:
            floorPlanStore.setEditState(FloorPlanEditState.Mark);
            break;
        case FloorPlanEditState.Mark:
            floorPlanStore.setEditState(FloorPlanEditState.Connect);
            break;
        case FloorPlanEditState.Connect:
            floorPlanStore.setEditState(FloorPlanEditState.Finish);
            break;
    }
};
var backToPreviousState = function (floorPlanStore) {
    switch (floorPlanStore.editState) {
        case FloorPlanEditState.Finish:
            floorPlanStore.setEditState(FloorPlanEditState.Connect);
            break;
        case FloorPlanEditState.Connect:
            floorPlanStore.setEditState(FloorPlanEditState.Mark);
            break;
        case FloorPlanEditState.Mark:
            floorPlanStore.setEditState(FloorPlanEditState.Upload);
            break;
    }
};
var moveToState = function (floorPlanStore, state) {
    floorPlanStore.setEditState(state);
};
var cancelChanges = function () {
    // FIXME: This would not work for a user coming to floor planner url from outside of portal.
    // Should this action be passed to the FloorPlannerApp?
    window.history.back();
};
var downloadCsvFile = function (labelsStore, floorPlanStore) {
    if (labelsStore && floorPlanStore) {
        var moveId = floorPlanStore.moveId;
        if (moveId) {
            labelsStore.downloadLabelsCsvFile(moveId);
        }
    }
};
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Home.prototype.componentDidMount = function () {
        var _a = this.props, floorPlanStore = _a.floorPlanStore, moveId = _a.moveId, accessToken = _a.accessToken;
        if (floorPlanStore) {
            floorPlanStore.moveId = moveId;
            floorPlanStore.setAccessToken(accessToken);
            floorPlanStore.fetchMove(moveId);
            floorPlanStore.refreshLayouts();
        }
    };
    Home.prototype.render = function () {
        var _a = this.props, floorPlanStore = _a.floorPlanStore, labelsStore = _a.labelsStore;
        if (!floorPlanStore) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { marginBottom: '98px' } }, renderFloorPlanState(floorPlanStore)),
            React.createElement(Footer, { floorPlanStore: floorPlanStore, onContinue: continueNextState.bind(this, floorPlanStore), onPrevious: backToPreviousState.bind(this, floorPlanStore), onCancel: cancelChanges, onFinish: downloadCsvFile.bind(this, labelsStore, floorPlanStore), onStateClick: moveToState.bind(this, floorPlanStore) })));
    };
    Home = __decorate([
        inject('floorPlanStore'),
        inject('labelsStore'),
        observer
    ], Home);
    return Home;
}(React.Component));
export default Home;
//# sourceMappingURL=FloorPlanEdit.js.map